import {  getRequest, postRequest,deleteRequest } from "./RequestConfig";

export const getPartsList = async () => {
  try {
    const response = await getRequest("maintenance/parts/list");
    return response;
  } catch (error) {
    throw error;
  }
};

export const createPart = async (data) => {
  try {
    const response = await postRequest("maintenance/parts/save", data);
    return response;
  } catch (error) {
    throw error;
  }
};
export const updatePart = async (data) => {
  try {
    const response = await postRequest("maintenance/parts/save", data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deletePart = async (id) => {
  try {
    const response = await deleteRequest(`maintenance/parts/delete?partsId=${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getPartsQuantityList = async (debiId) => {
  const debiID = debiId?.craetedebiFlag? debiId?.response?.id : debiId;
  try {
    const response = await getRequest(`debi/partDetails/list?debiId=${debiID}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const createQuantityPart = async (data) => {
  try {
    const response = await postRequest("debi/partDetails/save", data);
    return response;
  } catch (error) {
    throw error;
  }
};
export const updateQuantityPart = async (data) => {
  try {
    const response = await postRequest("debi/partDetails/save", data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteQuantityPart = async (id) => {
  try {
    const response = await deleteRequest(`debi/partDetails/delete?id=${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

